
import CobraDocuments from "@/components/documents/CobraDocuments.vue";
import GroupInsuranceDocuments from "@/components/documents/GroupInsuranceDocuments.vue";
import { defineComponent } from "vue";
import { mapGetters } from "vuex";

export default defineComponent({
  name: "DocumentView",
  components: {
    CobraDocuments,
    GroupInsuranceDocuments,
  },
  data() {
    return {
      enrollmentType: 0 as number,
    };
  },
  computed: {
    ...mapGetters(["getEnrollment"]),
  },
  async created() {
    this.enrollmentType = this.getEnrollment.serviceType;
  },
});
